import { render, staticRenderFns } from "./AddTechRatesModal.vue?vue&type=template&id=edf08018&scoped=true&"
import script from "./AddTechRatesModal.vue?vue&type=script&lang=js&"
export * from "./AddTechRatesModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTechRatesModal.vue?vue&type=style&index=0&id=edf08018&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf08018",
  null
  
)

export default component.exports